import React, { Component } from 'react';
import _                    from 'lodash';

class Links extends Component
{

    getLinkByLabel = (label) =>
    {
        return _.find(this.props.links, (link) => { return link.label === label });
    };

    renderLink = (link) =>
    {
        return (
            <li key={ link.label }>
                <a href={ link.uri }>{ link.text }</a>
            </li>
        );
    };

    render = () =>
    {
        return (
            <ul>
                { this.renderLink(this.getLinkByLabel('about')) }
                { this.renderLink(this.getLinkByLabel('contact')) }
                { this.renderLink({ label: 'cms', uri: 'https://cms.placesandtrails.com', text: 'Client Log In' }) }
            </ul>

        );
    }
}

export default Links;


// WEBPACK FOOTER //
// ./src/components/Links.js